import { VStack, Text, DataList } from '@cad-arc';
import { ReactNode } from 'react';

export function FiltersSummary({ title, children }: { title: string; children: ReactNode }) {
    return (
        <VStack align="left" maxWidth="20%">
            <Text variant="headingXs">{title}</Text>
            <VStack align="left" gap="4px">
                <DataList>{children}</DataList>
            </VStack>
        </VStack>
    );
}
